import { render, staticRenderFns } from "./CarOverallInfo.vue?vue&type=template&id=01c6f1aa&scoped=true&"
import script from "./CarOverallInfo.vue?vue&type=script&lang=js&"
export * from "./CarOverallInfo.vue?vue&type=script&lang=js&"
import style0 from "./CarOverallInfo.vue?vue&type=style&index=0&id=01c6f1aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c6f1aa",
  null
  
)

export default component.exports